/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { SellerContractPdfDocument } from './SellerContractPdfDocument';

interface SupplierContractItem {
  supid: number;
  year: number;
  name: string;
  contact: {
    email1?: string;
    email2?: string;
    contact1?: string;
    contact2?: string;
    contact3?: string;
  };
  legalRep: string;
}

interface SellerContractPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  contract: SupplierContractItem | null;
  details: any[];
  loading?: boolean;
}

export function SellerContractPreviewModal({
  isOpen,
  onClose,
  contract,
  details = [],
  loading = false,
}: SellerContractPreviewModalProps): React.ReactElement | null {
  if (!isOpen || !contract) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      role="dialog"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.65)', zIndex: 1050 }}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: '92%', margin: '20px auto' }}>
        <div className="modal-content" style={{ borderRadius: 8, boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }}>
          <div
            className="modal-header"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 20px',
              borderBottom: '1px solid #e9ecef',
            }}
          >
            <h5 className="modal-title" style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>
              <i className="fas fa-file-alt text-primary" style={{ marginRight: 8 }}></i>
              Contract PDF Preview - {contract.name || `Seller ${contract.supid}`} ({contract.year})
            </h5>
            <button
              type="button"
              className="close"
              onClick={onClose}
              style={{ fontSize: 22, background: 'none', border: 'none', cursor: 'pointer', outline: 'none' }}
            >
              &times;
            </button>
          </div>

          <div className="modal-body" style={{ padding: 15, backgroundColor: '#f8f9fa' }}>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                <i className="fas fa-spinner fa-spin fa-2x text-primary" style={{ marginBottom: 12 }}></i>
                <div>Loading contract details...</div>
              </div>
            ) : (
              <PDFViewer style={{ width: '100%', height: '76vh', border: '1px solid #ced4da', borderRadius: 6 }}>
                <SellerContractPdfDocument contract={contract} details={details} />
              </PDFViewer>
            )}
          </div>

          <div className="modal-footer" style={{ padding: '10px 20px', borderTop: '1px solid #e9ecef' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
